/**
 * @generated SignedSource<<6acf41e863887270fd28e02889243563>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GetS3VideoDataV2Input = {
  clientMutationId?: string | null;
  folder: string;
  videoElementId?: string | null;
};
export type s3VideoSourceField_GetS3VideoDataV2Mutation$variables = {
  input: GetS3VideoDataV2Input;
};
export type s3VideoSourceField_GetS3VideoDataV2Mutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly getS3VideoData: {
        readonly s3VideoData: {
          readonly contentType: string;
          readonly invalidSubtitles: ReadonlyArray<{
            readonly invalidLine: string | null;
            readonly keepsPublishedVersion: boolean;
            readonly language: string;
          }>;
          readonly playbackUrl: string;
          readonly sizeInBytes: any;
          readonly subtitleLanguages: ReadonlyArray<string>;
          readonly videoKey: string;
        } | null;
      } | null;
    };
  };
};
export type s3VideoSourceField_GetS3VideoDataV2Mutation = {
  response: s3VideoSourceField_GetS3VideoDataV2Mutation$data;
  variables: s3VideoSourceField_GetS3VideoDataV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElearningV2AdminMutationSchema",
        "kind": "LinkedField",
        "name": "ElearningV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "GetS3VideoDataV2Payload",
            "kind": "LinkedField",
            "name": "getS3VideoData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "S3VideoDataV2",
                "kind": "LinkedField",
                "name": "s3VideoData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "videoKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sizeInBytes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subtitleLanguages",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "S3InvalidSubtitleV2",
                    "kind": "LinkedField",
                    "name": "invalidSubtitles",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "language",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "invalidLine",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "keepsPublishedVersion",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "playbackUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "s3VideoSourceField_GetS3VideoDataV2Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "s3VideoSourceField_GetS3VideoDataV2Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c0c9a4d27836b81f7af3dbdb3e18b128",
    "id": null,
    "metadata": {},
    "name": "s3VideoSourceField_GetS3VideoDataV2Mutation",
    "operationKind": "mutation",
    "text": "mutation s3VideoSourceField_GetS3VideoDataV2Mutation(\n  $input: GetS3VideoDataV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      getS3VideoData(input: $input) {\n        s3VideoData {\n          videoKey\n          sizeInBytes\n          contentType\n          subtitleLanguages\n          invalidSubtitles {\n            language\n            invalidLine\n            keepsPublishedVersion\n          }\n          playbackUrl\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd75fb7402ba48968ef2271c208ae3c7";

export default node;
